class EsShop {
	constructor(array){
		this.array = array;
		this.res = [];
		this.itemCount = 1;
	}

	beforeBuildShop(box, typo){
		let btn = `<div class="row"><div class="col-12 text-center">
		  <button type="button" class="btn btn-success moreitem" data-typo="${typo}">Load more</button>
		</div></div>`;
		let btnBox = document.getElementById(box+typo);
		btnBox.innerHTML = '';
		this.addHtml(btnBox, 3, 'html', btn);
	}

	buildShop(box, typo, limit){
		let tpl = function(product, image, price, index){
		  const [cost, integer, decimal] =  price.match(/^(\d+\.?\-?)(\d*)/);
			return `<div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 text-center article_link" data-model="${product}">
			  <a href="item.html">
			    <img src="${image}" alt="${product} - ${price}" onerror="this.src='uploads/onsearch.jpg';" />
			    <p class="item-text ml-3 mr-3 pt-2">${product}</p>
			  </a>
			  <span class="price item-price">${integer}${decimal ? "" : "-"}
			    <span class="cents">${decimal ? (decimal + "0").slice(0, 2) : ""
				}</span>
				</span>
				<div class="btn-group-sm">
				<button type="button" class="btn btn-success item-compare">compare +</button>
				<button type="button" class="btn btn-success item-buy">buy</button>
				</div>
			</div>`;
		}

		let count = this.itemCount;
		let btnBox = document.getElementById(box+typo);
		if( count <= 1 ){
			this.beforeBuildShop('products', 'Sale');
			this.beforeBuildShop('products', 'Hit');
		}
		this.array.forEach( (el, idx) => {
			if( idx >= (limit * count - limit) && idx < (limit*count) ){
				this.addHtml(btnBox, 2, 'html', tpl( el['product'], el['image'], el['price'], idx));
			}
			if( idx > limit*count) return;
		});

		this.itemCount += 1;
	}

	addHtml(el, numArea, metod, tpl){
	  let mtd = {
	    html:'insertAdjacentHTML',
	    text:'insertAdjacentText',
	    elem:'insertAdjacentElement',
	    0:'beforebegin',
	    1:'afterbegin',
	    2:'beforeend',
	    3:'afterend'
	  };
	  el[mtd[metod]](mtd[numArea], tpl);
	  return this;
	}
}

fetch("json/data.json").then( (response) =>
		response.json()
	).then( (products) => {

	let shop = new EsShop(products);

	shop.buildShop('products', 'Sale', 2);
	shop.buildShop('products', 'Hit', 4);

	document.addEventListener('click', function(e){
		let target = e.target;
		if( target.tagName === 'BUTTON' && target.classList.contains('moreitem')){
			let typo = target.getAttribute('data-typo');
			shop.buildShop('products', typo, 2);
		}
		return false;
	});
});